import {
  Clickable,
  ForEach,
  IconName,
  Tabs,
} from '@fashionnovateam/nova-ui-toolkit';

export type FilterElement<T> = {
  value: T;
  label: string;
  icon?: IconName;
  count?: number;
};

export type FilterTabProps<T> = {
  type?: 'segment' | 'underline';
  onChange: (value: T) => void;
  items: FilterElement<T>[];
  value: T;
};
export function FilterTab<T>({
  type = 'underline',
  value,
  onChange,
  items,
}: FilterTabProps<T>) {
  return (
    <Tabs.Group type={type}>
      <ForEach items={items}>
        {(item) => (
          <Clickable key={item.label} onClick={() => onChange(item.value)}>
            <Tabs.Item
              className="whitespace-nowrap"
              isActive={value === item.value}
              icon={item.icon}
              countBadge={item.count}
              type={type}
            >
              {item.label}
            </Tabs.Item>
          </Clickable>
        )}
      </ForEach>
    </Tabs.Group>
  );
}
